import { date } from "date-typescript-library";

export function calcularDiasCorridos(dataIni, dias) {

    let result = new Date(dataIni);
    let ms = result.getTime() + (dias * 24 * 60 * 60 * 1000);

    return date('Y-m-d', ms);
}

export function checarSeDataEstaEntreAsDatas(data_ini,data_fim,data_checar) {

    var fDate,lDate,cDate;
    fDate = Date.parse(data_ini);
    lDate = Date.parse(data_fim);
    cDate = Date.parse(data_checar);

    if((cDate <= lDate && cDate >= fDate)) {
        return true;
    }
    return false;
}

export function calcularSeDataFinalEhAnteriorAHoje(data_fim) {
  
      var fDate,lDate;

      fDate = Date.parse(data_fim);
      lDate = Date.parse(new Date());
  
      if((fDate < lDate)) {
          return true;
      }
      return false;
}

export function tratarMensagemDeErro(erro) {

    if(typeof erro == 'object'){
        
      if(typeof erro?.error == 'string'){
        return erro.error;
      }
    }
    

    return erro;

}